export const PlayBtnIcon = () => {
  return (
    <svg width="14" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.5302 7.95502L2.56138 12.5087C1.82806 12.9277 0.915625 12.3982 0.915625 11.5536L0.915625 2.44631C0.915625 1.60171 1.82806 1.07221 2.56138 1.49125L10.5302 6.04489C11.2692 6.46717 11.2692 7.53274 10.5302 7.95502Z"
        stroke="white"
        strokeWidth="1.8"
      />
    </svg>
  );
};
